import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Web3Provider } from './providers/Web3Provider'
import { AuthSessionProvider } from './contexts/AuthSessionContext'
import App from './App.jsx'
import './index.css'
import { initPwa } from './pwa/pwaState'

initPwa()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Web3Provider>
      <AuthSessionProvider>
        <App />
      </AuthSessionProvider>
    </Web3Provider>
  </StrictMode>
)
